import React, { useState, useEffect, useContext } from "react";
import { Routes, Route } from "react-router-dom";

import ContextComponent from "../../AppContext";
import CardList from "./cards/CardsList";
import TemplateList from "./templates/TemplatesList";
import BrandsTable from "./brands/BrandsTable";
import AddTemplate from "./templates/AddTemplate";
import EditTemplate from "./templates/EditTemplate";
import Utils from "../../Utils";
import Addresses from "../../pages/Addresses";
import BadgesTable from "./badges/BadgesTable";
import AddBadgePage from "./badges/AddBadgePage";
import AddressesTable from "./addresses/AddressesTable";
import UsersTable from "./users/UsersTable";
import EmailSignature from "../../pages/signatures/EmailSignature";
import Contacts from "../../pages/Contacts";
import Settings from "./users/Settings";
import Analytics from "../../pages/Analytics";
import AddCard from "./cards/AddCard";
import EditCard from "./cards/EditCardPage";
import CardDetailsPage from "./cards/CardDetailsPage";

const ContentArea = () => {
  let [admin, setAdmin] = useState(false);
  let [superAdmin, setSuperAdmin] = useState(false);
  let [canRender, setCanRender] = useState(false);

  let { userData, addrCtxData, setAddrCtxData, setCanRedirectToLogin } =
    useContext(ContextComponent);

  useEffect(() => {
    if (!Utils.isObjectEmpty(userData)) {
      setAdmin(!!userData?.admin);
      setSuperAdmin(!!userData?.superAdmin);

      const success = (res) => {
        let data = res.data;
        let tempAddrIds = [];
        let tempAddrNames = [];
        let tempAddrValues = [];
        let tempCityValues = [];
        let tempCountryValues = [];
        let tempZipValues = [];
        let tempFullAddrValues = [];
        let tempAddrNumbers = [];
        let tempAddrBrands = [];

        data = data.sort((a, b) => (a.name > b.name ? 1 : -1));

        data.map((addr, index) => {
          //debugger;
          tempAddrIds.push(addr.id);
          tempAddrNames.push(addr.name);

          let address = addr?.address || "";
          let city = addr?.city || "";
          let country = addr?.country || "";
          let zip = addr?.zip || "";

          tempAddrValues.push(address);
          tempCityValues.push(city);
          tempCountryValues.push(country);
          tempZipValues.push(zip);

          tempFullAddrValues.push(
            address + " " + city + " " + country + " " + zip,
          );
          tempAddrNumbers.push(addr.contact);
          tempAddrBrands.push(addr.brand);
        });

        let addrObj = {
          ids: tempAddrIds,
          addressNames: tempAddrNames,
          addresses: tempAddrValues,
          cities: tempCityValues,
          countries: tempCountryValues,
          fullAddresses: tempFullAddrValues,
          numbers: tempAddrNumbers,
          brands: tempAddrBrands,
        };
        setAddrCtxData(addrObj);
        setCanRender(true);
      };
      const fail = (err) => {
        console.log(err);
        setCanRedirectToLogin(true);
      };

      try {
        Utils.getAddresses().then(success, fail);
      } catch (e) {
        console.log(e);
      }
    }
  }, [userData]);

  return (
    <>
      {canRender && (
        <div className="indi-content-area-wrapper d-flex h-100">
          <Routes>
            {superAdmin && (
              <Route
                path={Utils.APP_URLS.LANDING_PAGE}
                exact
                element={<BrandsTable />}
              ></Route>
            )}

            {superAdmin && (
              <Route
                path={Utils.APP_URLS.TEMPLATES_PAGE}
                exact
                element={<TemplateList />}
              ></Route>
            )}

            {superAdmin && (
              <Route
                path={Utils.APP_URLS.BRANDS_PAGE}
                exact
                element={<BrandsTable />}
              ></Route>
            )}

            {superAdmin && (
              <Route
                path={Utils.APP_URLS.ADD_TEMPLATE_PAGE}
                exact
                element={<AddTemplate />}
              ></Route>
            )}

            {superAdmin && (
              <Route
                path={Utils.APP_URLS.EDIT_TEMPLATE_PAGE}
                exact
                element={<EditTemplate />}
              ></Route>
            )}

            {!admin && (
              <Route
                path={Utils.APP_URLS.LANDING_PAGE}
                exact
                element={<CardList />}
              ></Route>
            )}

            {admin && (
              <Route
                path={Utils.APP_URLS.LANDING_PAGE}
                exact
                element={<UsersTable />}
              ></Route>
            )}

            <Route
              path={Utils.APP_URLS.CARDS_PAGE}
              exact
              element={<CardList />}
            ></Route>

            <Route
              path={Utils.APP_URLS.CARD_DETAILS_PAGE}
              exact
              element={<CardDetailsPage />}
            ></Route>

            <Route
              path={Utils.APP_URLS.ADD_CARD_PAGE}
              exact
              element={<AddCard />}
            ></Route>

            <Route
              path={Utils.APP_URLS.EDIT_CARD_PAGE}
              exact
              element={<EditCard />}
            ></Route>

            {(admin || superAdmin) && (
              <Route
                path={Utils.APP_URLS.ADDRESS_PAGE}
                exact
                element={<AddressesTable />}
              ></Route>
            )}

            {superAdmin && (
              <Route
                path={Utils.APP_URLS.BADGES_PAGE}
                exact
                element={<BadgesTable />}
              ></Route>
            )}

            {superAdmin && (
              <Route
                path={Utils.APP_URLS.ADD_BADGE_PAGE}
                exact
                element={<AddBadgePage />}
              ></Route>
            )}

            {(admin || superAdmin) && (
              <Route
                path={Utils.APP_URLS.USERS_PAGE}
                exact
                element={<UsersTable />}
              ></Route>
            )}

            <Route
              path={Utils.APP_URLS.EMAIL_SIGNAURE_PAGE}
              exact
              element={<EmailSignature />}
            ></Route>

            <Route
              path={Utils.APP_URLS.CONTACTS_PAGE}
              exact
              element={<Contacts />}
            ></Route>

            <Route
              path={Utils.APP_URLS.SETTINGS_PAGE}
              exact
              element={<Settings />}
            ></Route>

            {superAdmin && (
              <Route
                path={Utils.APP_URLS.ANALYTICS_PAGE}
                exact
                element={<Analytics />}
              ></Route>
            )}
          </Routes>
        </div>
      )}
    </>
  );
};

export default ContentArea;
